module.exports = __webpack_public_path__ + "static/koubkova-cddf01b02056652e75cb225fa8468912.jpg";